

export default function MiniSection({title, sections}) {

    return (
        <div className="space-y-1">
            <h3 className="font-semibold" style={{ fontSize: "clamp(1.4rem, 4vw, 2rem)" }}>{title}</h3>
            <div className="space-y-2">
                {
                    sections.map((section, index) => (section))
                }
            </div>
        </div>
    )
}